import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { map } from "lodash"
import LeadBySource from "./lead"
import Apaexlinecolumn from "./apaexlinecolumn"
import Revnue from "../AllCharts/apex/revnueLine"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import WelcomeComp from "./WelcomeComp"
//import CalenderShort from "../Activities/calander-short"
import appointment from "../../assets/images/rsicons/appointment.png"
import activiti from "../../assets/images/rsicons/activities.png"
import call from "../../assets/images/rsicons/call.png"
import notes from "../../assets/images/rsicons/notes.png"
import todo from "../../assets/images/rsicons/to-do.png"
import Moment from "react-moment";
import moment from 'moment';
import { postActivityFilter } from "store/actions"
//import LatestLeads from "../Lead/LatestLeads"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Select,
  Nav,
  NavItem,
  NavLink
} from "reactstrap"
import { API_URL } from "helpers/app_url";
import axios from "axios";
import RsLink from "components/buttons/rsLink";
import RSBarChart from "components/charts/RSBarChart";
import classnames from "classnames"
class AllNotification extends Component {
  constructor(props) {
    super(props)
    this.state = {
        clientnotificationsData:[]
    }
  }
 


  componentDidMount() {
       this.fetchClientNotification();
  }

 fetchClientNotification() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      ForId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}Notification/allAgent`, { headers, params })
      .then((response) => {
        this.setState({ clientnotificationsData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  render() {
    const {clientnotificationsData} = this.state;
   
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Lead Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Lead")}
              breadcrumbItem={this.props.t("Dashboard")}
            /> */}
           
            <Row >
             
             <Col lg={12}>
                 <Card className="border-full w-100">
                <CardBody className="d-flex flex-column">
                    <div className="card-title mb-4 float-start card-bottom-border">All Notification</div>
                    <Table
                      id=""
                      className="table table-striped table-bordered border-left-off"
                    >
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th></th>
                         
                        </tr>
                      </thead>
                      <tbody>
                        {clientnotificationsData.map((project, index) => ( 
                          <tr key={index}>
                          <td><Moment format="DD MMM YYYY">{project.notificationDate}</Moment>
                           
                          </td>
                          <td>{project.notificationText	}</td>
                        
                        </tr>
                        ))}
                       

                      </tbody>
                    </Table>
                 </CardBody>
                 </Card>
              </Col>
            
            </Row>
           
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
AllNotification.propTypes = {
  t: PropTypes.any,
  

}
const mapStateToProps = () => (
  {
    
   
  })
const mapDispatchToProps = dispatch => ({

 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AllNotification))
